import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, of, take, tap } from 'rxjs';
import { ITrackerConfig, ITrackerParams } from '../interface';

@Injectable({
  providedIn: 'root'
})
export class TrackerService {
  // make tracker isolated service
  private http = inject(HttpClient);

  constructor() {}

  // track navigation event. 
  // records the screen name in a dedicated table, does not stop the process on any type of error.
  trackNavigation(config: ITrackerConfig, params: ITrackerParams): void {
    this.http.post(config.url, params, {context: config.httpContext}).pipe(
      take(1), 
      catchError((error: any) => {
        console.log(`trackNavigation exeption `, error);
        return of(); // swallow error
      }),
      tap((data: any) => {
        console.log(`${params.screenName} was tracked successfully. response: `, data?.result?.timestamp);
        /** store response data */
      })
    ).subscribe();
  }
}
